import { createSlice } from "@reduxjs/toolkit";

const fontsSlice = createSlice({
  name: "fonts",
  initialState: {
    version: 0, // if version changes fonts will be reloaded => only change it if you put new fonts
    fonts: [], // fonts in base64 to load from redux
  },
  reducers: {
    setFonts: (state, action) => {
      const { version = 0 , fonts = [] } = action.payload;
      state.version = version;
      state.fonts = fonts;
    },
  },
});

export const { setFonts } = fontsSlice.actions;
export default fontsSlice.reducer;
